import { ChecklistConstants } from "./checklist.constants";
import { MediaObjectConstants } from "./media-object";
import { PwaConstants } from "./pwa.constants";

export const NetworkConstants = {
  Functions: {
    createWorkOrder: "INS_AddWorkOrder",
    addTestResult: "INS_AddTestResult",
    completeWorkOrder: "INS_ChecklistCompleted",
    getUserBranch: "INS_GetUserBranch",
  },
  Queries: {
    preloadEquipmentMaster: "INS_PreloadEquipmentMaster",
    getChecklist: "INS_GetWorkOrderTest",
    preloadUDC: "INS_PreloadUserDefinedCodes",
    getWorkOrders: "INS_GetWorkOrderByAssetNo",
    getQuestionResponses: "INS_GetWorkOrdersTestResultsActual",
  },
  Media: {
    uploadMedia: "Attach",
    mediaRequest: "mediaRequest",
    getText: "GetText",
    addText: "AddText",
    updateText: "UpdateText",
  },
} as const;

export const Constants = {
  Network: NetworkConstants,
  MediaObject: MediaObjectConstants,
  Checklist: ChecklistConstants,
  Pwa: PwaConstants,
} as const;
